import type { PushToken } from 'src/entities/push'
import type { IPushBridge } from './ports/IPushBridge'

// Сценарий: при открытии приложения спросить разрешение и получить токен FCM.
export class PreparePush {
  constructor(private readonly bridge: IPushBridge) {}

  execute(): Promise<PushToken> | null {
    return this.bridge.isAvailable() ? this.bridge.getToken() : null
  }
}
